"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAPI = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
const fetchAPI = (url, options) => {
    options = Object.assign({
        method: 'GET',
    }, Object.assign({}, options));
    options.headers = Object.assign({
        Accept: 'application/json',
        'Content-type': 'application/json',
    }, Object.assign({}, options === null || options === void 0 ? void 0 : options.headers));
    return new Promise((resolve, reject) => {
        fetch(url, options)
            .then((res) => res.json())
            .then((result) => {
            if (result.statusCode >= 500) {
                console.error(result.message);
                return reject(new Error('Error in EKC Proxy Server'));
            }
            if (result.statusCode >= 400) {
                console.error(result.message);
                return reject(new Error(result.message));
            }
            resolve(result);
        })
            .catch((err) => {
            console.error(err);
            reject(new Error('Error in EKC Proxy Server'));
        });
    });
};
exports.fetchAPI = fetchAPI;
